module.exports = __webpack_public_path__ + "26745b127b494013728cf8406769327d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boots-pirate.png
// module id = 2394
// module chunks = 0